var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hideshow),expression:"hideshow"}],staticClass:"Copyright"},[_vm._v(" "+_vm._s(_vm.stringList.powered_hospitality_voice)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }